import { Close, InfoOutlined } from '@mui/icons-material';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton } from '@mui/material';
import { Component } from 'react';

export default class ExclusionDeleteConfirmationModal extends Component
{
    render()
    {
        const { action, onCancel, loading } = this.props;

        return (
            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={true}
                onClose={onCancel}
            >
                <DialogTitle id="delete-excl-user" sx={{ m: 0, p: 2 }}>
                    Remove user from exclusion list?
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'black.900'
                    }}
                >
                    <Close />
                </IconButton>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                    <DialogContentText id="alert-dialog-description" style={{ marginTop: -20, fontSize: 12 }}>
                        This action will remove the borrower from the exclusion list. This will allow the borrower to be included in the census file processing.
                    </DialogContentText>

                    <DialogContentText>
                        <Alert variant='filled' severity="warning" sx={{
                            backgroundColor: '#FFCC80', // light orange
                            color: '#663C00', // dark text for contrast
                            fontSize: 12
                        }} icon={<InfoOutlined color='warning' />} >
                            Please note that this user will be considered as a new hire after removal from this list, if not present in the old census file
                        </Alert>
                    </DialogContentText>

                    <DialogContentText id="alert-dialog-description" style={{ fontSize: 12 }}>
                        Do you want to continue and remove the user from the list?
                    </DialogContentText>

                </DialogContent>
                <Divider />

                <DialogActions style={{ justifyContent: 'space-between', padding: 20 }}>

                    <Button onClick={onCancel} variant="outlined" color="warning">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={action}
                        color="primary"
                        autoFocus
                        disabled={loading}
                    >
                        Continue
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }
}
